export default __webpack_public_path__ + "static/media/typescript-icon.78aa7804.svg";